module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('claim-text-field', {
    attrs: {
      "error": _vm.$attrs.errors.claim.text
    },
    model: {
      value: (_vm.$attrs.claim.text),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.claim, "text", $$v)
      },
      expression: "$attrs.claim.text"
    }
  }), _vm._v(" "), _c('date-time-field', {
    attrs: {
      "error": _vm.$attrs.errors.claim.datetime
    },
    model: {
      value: (_vm.$attrs.claim.datetime),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.claim, "datetime", $$v)
      },
      expression: "$attrs.claim.datetime"
    }
  }), _vm._v(" "), _c('client-field', {
    attrs: {
      "error": _vm.$attrs.errors.claim.client
    },
    model: {
      value: (_vm.$attrs.claim.client),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.claim, "client", $$v)
      },
      expression: "$attrs.claim.client"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf3fb49e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/claim/ClaimBlankForm.vue
// module id = 711
// module chunks = 0